import { CustomersDashboardIconNotChosen, CustomersDashboardIcon, AccountNivIcon, AccountNivSelectedIcon, DiscoveryIcon, DiscoveryIconSelected, IdeasIcon, IdeasIconSelected, ImportNivIcon, ImportSelectedNivIcon, IntegrationsNivIcon, IntegrationsSelectedNivIcon, MembersNivIcon, MembersNivSelectedIcon, ObjectsFieldsNivIcon, ObjectsFieldsSelectedNivIcon, ReportsIcon, ReportsIconSelected, RequestsIcon, RequestsIconSelected, TeamsNivIcon, TeamsNivSelectedIcon } from "../../icons/x-symbol-svgrepo-com";
import { IconFileExport, IconTag, IconShield, IconBrain , IconBell, IconSettings, IconKey, IconTool, IconFilter, IconDatabase, IconAdjustments, IconBox, IconClipboardList, IconRocket, IconTarget } from "@tabler/icons";
import { ExploreSparklesIcon } from "../../icons/ExploreSparklesIcon";
import { FULL_MANAGER_ROLES, IDEAS_VIEW_ROLES, VALID_APP_ROLES, BAGEL_OBJECTS_ROLES } from '../../hooks/useUserPermissions';

export const showTopReports = window.__RUNTIME_CONFIG__.REACT_APP_SHOW_TOP_REPORT === "true";

export const mainLinks = [
  { link: "/explore", label: "Explore", icon: ExploreSparklesIcon, activeIcon: ExploreSparklesIcon, disabled: false, roles: VALID_APP_ROLES, requiresCanSeeExplore: true },
  { link: "/discovery", label: "Discovery", icon: DiscoveryIcon, activeIcon: DiscoveryIconSelected, disabled: false, roles: VALID_APP_ROLES, hideForExploreUsers: true },
  { 
    link: "/evidences/inbox",
    label: "Inbox",
    icon: RequestsIcon, activeIcon: RequestsIconSelected,
    disabled: false,
    roles: FULL_MANAGER_ROLES
  },
  {
    link: "/ideas/all",
    label: "Ideas", 
    icon: IdeasIcon, 
    activeIcon: IdeasIconSelected, 
    disabled: false,
    isMenuTrigger: true,
    style: { cursor: 'default' },
    children: [
      { link: "/ideas/all", label: "All", disabled: false }, 
      { link: "/ideas/archived", label: "Archived", disabled: false },
    ],
    roles: IDEAS_VIEW_ROLES
  },
  {
    link: "/trends",
    label: "Trends",
    icon: ReportsIcon,
    activeIcon: ReportsIconSelected,
    disabled: !showTopReports,
    roles: IDEAS_VIEW_ROLES
  },/* {
    link: "/customer360",
    label: "Customer 360",
    icon: CustomersDashboardIconNotChosen,
    activeIcon: CustomersDashboardIcon,
    roles: ['manager', 'admin','agent']
  }, */
  {
    link: "/customer360",
    label: "Customer 360",
    icon: CustomersDashboardIconNotChosen,
    activeIcon: CustomersDashboardIcon,
    roles: VALID_APP_ROLES,
    /* onlyBagel: true, */ // Can remove later when ready for production
  },
];

export const settingsLinks = [
  {
    section: "General",
    items: [
      { link: "/settings/account", label: "Account", icon: AccountNivIcon, activeIcon: AccountNivSelectedIcon },
      { link: "/settings/members", label: "Members", icon: MembersNivIcon, activeIcon: MembersNivSelectedIcon },
      { link: "/settings/teams", label: "Teams", icon: TeamsNivIcon, activeIcon: TeamsNivSelectedIcon },
      { link: "/settings/notifications", label: "Notifications", icon: IconBell, activeIcon: IconBell },
    ],
  },
  {
    section: "Data",
    items: [
      { link: "/settings/integrations2.0", label: "Integrations", icon: IntegrationsNivIcon, activeIcon: IntegrationsSelectedNivIcon },
      { link: "/settings/bagel-objects", label: "Bagel Objects", icon: IntegrationsNivIcon, activeIcon: IntegrationsNivIcon, roles: BAGEL_OBJECTS_ROLES },
      {
        link: "/settings/import",
        label: "Import",
        icon: ImportNivIcon,
        activeIcon: ImportSelectedNivIcon,
        children: [
          { link: "/settings/import/ideas_evidence", label: "Ideas and evidence" },
          { link: "/settings/import/items", label: "Potential evidence" },
        ],
      },
      {
        link: "/settings/export",
        label: "Export",
        icon: IconFileExport,
        activeIcon: IconFileExport,
        children: [
          { link: "/settings/export/ideas", label: "Ideas" },
          { link: "/settings/export/items", label: "Evidence" },
        ],
      },
    ],
  },
  {
    section: "Customization",
    items: [
      { link: "/settings/productareas", label: "Product Tree", icon: ObjectsFieldsNivIcon, activeIcon: ObjectsFieldsSelectedNivIcon },
      { link: "/settings/objects", label: "Objects & fields", icon: IconDatabase, activeIcon: IconDatabase },
      { link: "/settings/tags", label: "Tags", icon: IconTag, activeIcon: IconTag },
      { link: "/settings/releases", label: "Releases", icon: IconRocket, activeIcon: IconRocket },
      { link: "/settings/strategic-scopes", onlyBagelAdmin: true, label: "Strategic Scopes", icon: IconTarget, activeIcon: IconTarget },
      { link: "/settings/property", onlyBagel: true, label: "KPIs", icon: IconAdjustments, activeIcon: IconAdjustments },
      { link: "/settings/filters", label: "Filters", icon: IconFilter, activeIcon: IconFilter },
    ],
  },
  {
    section: "Privacy & Security",
    items: [
      { link: "/settings/pii-redaction", label: "PII Redaction", icon: IconShield, activeIcon: IconShield },
      { link: "/settings/tokens", label: "API Keys", icon: IconKey, activeIcon: IconKey },
      { link: "/settings/audit-logs", label: "Audit Log", icon: IconClipboardList, activeIcon: IconClipboardList },
    ],
  },
  {
    section: "Bagel Admins",
    items: [
      { link: "/settings/internal-items", label: "Internal Items", icon: IconBox, activeIcon: IconBox, onlyBagel: true },
      { link: "/settings/ml-settings", label: "ML Settings", icon: IconBrain, activeIcon: IconBrain, onlyBagel: true },
      { link: "/settings/field-configuration", onlyBagel: true, label: "Field Configuration", icon: IconSettings, activeIcon: IconSettings },
      { link: "/settings/admin/fixes", onlyBagelLead: true, label: "Fixes Manager", icon: IconTool, activeIcon: IconTool },
    ],
  },
];
